// Browser detection
const browser = (() => {
    const test = function(regexp) {return regexp.test(window.navigator.userAgent)}
    switch (true) {
        case test(/edg/i): return "Microsoft Edge";
        case test(/trident/i): return "Microsoft Internet Explorer";
        case test(/firefox|fxios/i): return "Mozilla Firefox";
        case test(/opr\//i): return "Opera";
        case test(/ucbrowser/i): return "UC Browser";
        case test(/samsungbrowser/i): return "Samsung Browser";
        case test(/chrome|chromium|crios/i): return "Google Chrome";
        case test(/safari/i): return "Apple Safari";
        default: return "Other";
    }
})();
if (browser === 'Apple Safari') {
    document.documentElement.classList.add('browser-safari');
}

// Device detection
const isIOS = (() => {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
})();
if (isIOS) {
    document.documentElement.classList.add('device-ios');
}

// Scroll to top
const scrollToTop = document.querySelector('.js-scroll-to-top');
scrollToTop.addEventListener('click', function() {
    document.documentElement.scrollTo({top: 0, behavior: 'smooth'})
})

// Simple accordion
// https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_accordion_animate
const accordions = document.querySelectorAll('.js-accordion');
function toggleAccordion(el) {
    const content = el.nextElementSibling;
    el.classList.toggle('active');
    content.style.maxHeight ?
        content.style.maxHeight = null :
        content.style.maxHeight = `${content.scrollHeight + 100}px`;
}

accordions.forEach(accordion => {
    accordion.addEventListener('click', function() {
        //accordions.forEach(el => { if (el.classList.contains('active')) toggleAccordion(el) });
        toggleAccordion(this);
    })
});


// Show/hide product description
const showMore = document.querySelector('#ShowHideDescription');
if ( showMore ) {
    showMore.addEventListener('click', function(){
        this.textContent = this.classList.contains('active') ? 'Hide' : 'Read more';
        toggleAccordion(this);
    });
}


// Custom plus/minus button for number input used in cart page
var cartPageQtyButtons = document.querySelectorAll('.template-cart form.cart button:not([type="submit"])');
cartPageQtyButtons.forEach(button => {
    button.addEventListener('click', function(e) {
        e.preventDefault();
    });
})



// Add video poster depending on media query
// const videoMedia = window.matchMedia("(max-width: 640px)");
// const videoPlayer = document.querySelector('.video-player');
// function changeVideoPoster(e) {
//     e.matches ?
//         videoPlayer.setAttribute('poster', videoPlayer.getAttribute('data-mobile-img')):
//         videoPlayer.setAttribute('poster', videoPlayer.getAttribute('data-desktop-img'));
// }

// if (videoPlayer) {
//     videoMedia.addListener(changeVideoPoster)
//     changeVideoPoster(videoMedia);
// }

// Custom play/pause video interactions
// const playButton = document.getElementById('PlayVideoButton');
// if (videoPlayer && playButton) {
//     videoPlayer.addEventListener('click', function() {
//         const player = this;
//         if (!player.classList.contains('interacted')) {
//             player.classList.add('interacted');

//             setTimeout(function() {
//                 player.classList.remove('interacted');
//             }, 2000)
//         }
//     })

//     playButton.addEventListener("click", function() {
//         if (videoPlayer.paused == true) {
//             // Play the video
//             videoPlayer.play();

//             videoPlayer.classList.add('video-played', 'video-playing')

//             // Update the button text to 'Pause'
//             playButton.querySelector('span').textContent = "Pause video";
//         } else {
//             // Pause the video
//             videoPlayer.pause();

//             videoPlayer.classList.remove('video-playing')

//             // Update the button text to 'Play'
//             playButton.querySelector('span').textContent = "Play video";
//         }

//         playButton.classList.toggle('is-active');
//     });
// }

// Convert the multiple player for slider
window.addEventListener("load",function(event) {

    jQuery('.btn--play-video').click(function() {
        var video = jQuery(this).parents('figure.video-banner').find('.video-player');

        if (video[0].paused == true) {
            // Play the video
            video[0].play();

            video.addClass('video-played video-playing')

            // Update the button text to 'Pause'
            jQuery(this).find('span').text("Pause video");
        } else {
            // Pause the video
            video[0].pause();

            video.removeClass('video-playing')

            // Update the button text to 'Play'
            jQuery(this).find('span').text("Play video");
        }

        jQuery(this).toggleClass('is-active');
    });
});


// Form submission trigger for mobile currency selector
const mobileCurrencySelector = document.querySelector('.mobile-nav .multi-selectors select')
function currencyFormSubmit(event) {
    event.target.form.submit();
}
if (mobileCurrencySelector) {
    mobileCurrencySelector.addEventListener('change', currencyFormSubmit)
}

const timeout = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
}


// Collection page change model selector functionality
const modelSelectorBtns = document.querySelectorAll('.js-change-model');
const clearModelBtn = document.querySelector('#ClearModelSelection');
const productGridImages = document.querySelectorAll('.grid-product__image-mask img[data-models]');
const mobileModelSelector = document.querySelector('#ModelSelector');

function looseJsonParse(obj){
    return Function('"use strict";return (' + obj + ')')();
}

function checkSelectValue(el) {
    let value = el.value

    if (value == 'clear') {
        localStorage.removeItem('model')
        productGridImages.forEach(image => {
            clearModelSelection(image)
        });
    }
    else {
        localStorage.setItem('model', value);
        updateModelImage(value)
    }
    document.querySelector('[data-scroll-to]').scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
}

function updateModelImagesSlideshow(selected) {
    let sliders = document.querySelectorAll('.grid-product__image-mask .flickity-slider');
    sliders.forEach((slider, index) => {
        let images = slider.querySelectorAll('img');

        let first_match = false;
        let first_match_index = 0;

        for (let i = 0; i < images.length; i++) {
            if (images[i].alt.charAt(0) == '_') {
                let alt_content = images[i].alt.split('_')[1];
                let alt_array = alt_content.split(',');
    
                if (alt_array.includes(`${selected}`)) {
                    first_match = images[i].closest('.image-wrap');
                    first_match_index = i;
                    break;
                }
            };
        }

        if (!first_match) return;

        window.dispatchEvent(new CustomEvent('selectProductGridItemSlide', {detail: {slider: index, index: first_match_index}}));

        return;
    })
}

function updateModelImage(selected) {
    let gridImages = document.querySelectorAll('.grid-product__image-mask img[data-models]');

    let is_slideshow = false;
    if (gridImages[0]?.classList.contains('grid-item-slideshow-img')) {
        is_slideshow = true;
    }
    if (is_slideshow) {
        updateModelImagesSlideshow(selected);
        return;
    }

    for (let image of gridImages) {
        const data = image.dataset.models
        const models = looseJsonParse(data)
        let hover = image.parentNode.nextSibling;

        if (hover.nodeType == 3) {
            hover = false
        }

        for (let i = 0; i < models.length; i++) {
            if (selected === models[i].name || selected === models[i].size) {
                image.parentNode.classList.add('display-model', 'loading')
                image.src = models[i].image
                if (hover) {
                    console.log({hover})
                    hover.style.backgroundImage = `url('${models[i].image}')`
                }

                if ( (i + 1) < models.length && selected === models[i + 1].name ) {
                    if (hover) {
                        hover.style.backgroundImage = `url('${models[i + 1].image}')`
                    }
                }

                image.addEventListener('load', () => image.parentNode.classList.remove('loading'))

                break
            }
            else
                clearModelSelection(image)

        };
    }
}

function clearModelSelectionSlideshow(image) {
    let sliders = document.querySelectorAll('.grid-product__image-mask .flickity-slider');
    sliders.forEach((slider, index) => {
        let first_match_index = 0;
        window.dispatchEvent(new CustomEvent('selectProductGridItemSlide', {detail: {slider: index, index: first_match_index}}));
        return;
    })
}

function clearModelSelection(image) {
    let gridImages = document.querySelectorAll('.grid-product__image-mask img[data-models]');
    
    let is_slideshow = false;
    if (gridImages[0]?.classList.contains('grid-item-slideshow-img')) {
        is_slideshow = true;
    }
    if (is_slideshow) {
        clearModelSelectionSlideshow(image);
        return;
    }

    let hover = image.parentNode.nextSibling
    if (hover.nodeType == 3) {
        hover = false
    }

    image.classList.remove('display-model')
    image.src = image.dataset.src

    if (!hover) return;

    hover.style.backgroundImage = `url('${hover.dataset.bg}')`;
}

modelSelectorBtns.forEach(button => {
    button.addEventListener('click', function(){
        modelSelectorBtns.forEach(button => button.classList.remove('active'));
        this.classList.add('active');
        localStorage.setItem('model', this.dataset.model);
        updateModelImage(this.dataset.model)
    });

    if (button.dataset.model == localStorage.getItem('model'))
        button.classList.add('active');
})

if (clearModelBtn) {
    clearModelBtn.addEventListener('click', function() {
        modelSelectorBtns.forEach(button => button.classList.remove('active'));
        localStorage.removeItem('model');
        productGridImages.forEach(image => {
            clearModelSelection(image)
        });
    })
}

if (mobileModelSelector) {
    mobileModelSelector.addEventListener('change', function(){
        checkSelectValue(this);
    });
}

window.addEventListener('load', event => {
    const mq = window.matchMedia('(max-width: 639px)');

    if (document.body.classList.contains('template-collection') && localStorage.getItem('model') ) {
        if (mq.matches){
            mobileModelSelector.value = localStorage.getItem('model');
            mobileModelSelector.dispatchEvent(new Event("change"));
        }
        else {
            updateModelImage(localStorage.getItem('model'))
        }
    }

    document.addEventListener('collectionContent:updated', async e => {
        // Timeout necessary for changes below to work after ajax filter on collections
        await timeout(300);
        if (document.body.classList.contains('template-collection') && localStorage.getItem('model') ) {
            if (mq.matches){
                mobileModelSelector.value = localStorage.getItem('model');
                mobileModelSelector.dispatchEvent(new Event("change"));
            }
            else {
                updateModelImage(localStorage.getItem('model'))
            }
        }
    })
});


// Product page change model selector functionality
const productChangeModelBtns = document.querySelectorAll('.js-product-change-model')
const clearModelSelector = document.querySelector('#ClearModelSelection');
const modelSelector = document.querySelector('#ChangeModel')
const productImages = document.querySelectorAll('.product-media');

function updateBtnText(button, model) {
    let btnText = button.querySelector('.text');
    btnText.textContent = `Model - ${model}`
}

function rearrangeProductImages(selected) {

    if (selected === 'reset') {
        $('.js-slick-slider').slick('slickGoTo', 0)
    }

    for (let image of productImages) {
        const data = image.dataset.imageAlt

        if (data.startsWith('_')) {
            // Using size instead of model
            const name = data.split('_')[1].split(',')[1];
            if (name.includes(selected)) {
                let position = image.dataset.position
                $('.js-slick-slider').slick('slickGoTo', position - 1)
                break
            }
        }
    }
}

function scrollIntoModel(model) {

    // Remove selected model class
    productImages.forEach(x => x.classList.remove('selected-model'))

    for (let image of productImages) {
        // Using size as model
        let name = (image.dataset.imageAlt).split('_')[1].split(',')[1];
        if (name === model) {
            image.classList.add('selected-model')
            image.scrollIntoView({behavior: "smooth"});
            break
        }
    }
}

for (let button of productChangeModelBtns) {
    if (button.dataset.model == localStorage.getItem('model'))
        button.classList.add('active')

    button.addEventListener('click', function() {
        const mq = window.matchMedia('(max-width: 769px)');

        if (localStorage.getItem('model') !== this.dataset.model) {
            productChangeModelBtns.forEach(btn => btn.classList.remove('active'))
            updateBtnText(modelSelector, this.dataset.model)
            localStorage.setItem('model', this.dataset.model)
            this.classList.add('active')

            mq.matches ?
                rearrangeProductImages(this.dataset.model) :
                scrollIntoModel(this.dataset.model)
        }
    })
}

if (clearModelSelector) {
    clearModelSelector.addEventListener('click', function(){
        productImages.forEach(x => x.classList.remove('selected-model'))
        if (modelSelector) modelSelector.querySelector('.text').textContent = 'Change model size'
        productChangeModelBtns.forEach(btn => btn.classList.remove('active'))
        localStorage.removeItem('model')
        rearrangeProductImages('reset')
    })
}

window.addEventListener('load', (event) => {
    const mq = window.matchMedia('(max-width: 769px)');

    if (document.body.classList.contains('template-product') && localStorage.getItem('model')) {
        updateBtnText(modelSelector, localStorage.getItem('model'))

        mq.matches ?
            rearrangeProductImages(localStorage.getItem('model')) :
            scrollIntoModel(localStorage.getItem('model'))
    }

    let productSliders = document.querySelectorAll('.product-grid-slideshow');
    let enabledSliders = [];

    // Interactive Size Guide
    function checkForResults() {
        let selected_type = $('.option-btn.type-btn.active').data('type');
        let region = $('.option-btn.region-btn.active').data('region');
        let size_combination = "";
        $('.type-container.active .region-container.active').find('.option-btn.active').each(function() {
            size_combination += $(this).text();
        });
        if(size_combination != "") {
            if (selected_type == "top" && tops_size_data[region][size_combination]) {
                $('.container-title').addClass('results');
                $('.size-guide-results').text(tops_size_data[region][size_combination]);
            } else if (selected_type == "bottom" && bottoms_size_data[region][size_combination]) {
                $('.container-title').addClass('results');
                $('.size-guide-results').text(bottoms_size_data[region][size_combination]);
            } else if (selected_type == "leggings" && one_pieces_size_data[region][size_combination]) {
                $('.container-title').addClass('results');
                $('.size-guide-results').text(one_pieces_size_data[region][size_combination]);

            } else {
                $('.container-title').removeClass('results');
                $('.size-guide-results').empty();
            }
        }
    }
    let sizeGuideOptionBtn = document.querySelectorAll('.option-btn');
    let skipSlide4 = false;
    if(sizeGuideOptionBtn.length > 0) {
        $('.option-btn').on('click', function() {
            let $this = $(this);
            $this.parent().find('.option-btn').removeClass('active');
            $this.addClass('active');
            $('.js-slide-size-guide').removeClass('disabled');

            // Check if button is a type button, change tab if so
            if ($this.hasClass('type-btn')) {
                let type = $this.data('type');
                $('.type-container').removeClass('active');
                $('.type-container[data-type="'+type+'"]').addClass('active');
                $('.type-container .option-btn').removeClass('active');
                $('.container-title').removeClass('results');
                $('.size-guide-results').empty();
                if(type == 'leggings' || type == 'bottom') {
                    skipSlide4 = true;
                } else {
                    skipSlide4 = false;
                }
            }

            // Check if button is a region button, change tab if so
            if ($this.hasClass('region-btn')) {
                let region = $this.data('region');
                $('.region-container').removeClass('active');
                $('.region-container[data-region="'+region+'"]').addClass('active');
            }

            // Change slide
            let slideNum = 0;
            let slideContainer = $this.closest('.slide-container');
            slideNum = slideContainer.data("slide");
            if(slideNum == 3 && skipSlide4) {
                slideNum = 5;
            }
            else if(slideNum < 5) {
                slideNum++
            }

            setTimeout(() => {
                $('.slide-container').removeClass('active');
                $('.slide-container[data-slide="'+slideNum+'"]').addClass('active');
                if(slideNum == 5) {
                    $('.slide-controls').css('display', 'none');
                    enableSliders();
                }
            },500);

            checkForResults();

        });
        checkForResults();
    }

    function startAgain() {
        skipSlide4 = false;
        $('.region-container').removeClass('active');
        $('.type-container').removeClass('active');
        $('.option-btn').removeClass('active');
        $('.slide-container').removeClass('active');
        $('.slide-previous.js-slide-size-guide').addClass('disabled');
        $('.slide-container[data-slide="1"]').addClass('active');
        $('.slide-controls').css('display', 'flex');
        enabledSliders.forEach(slider => {
            slider.destroy();
        })
        enabledSliders = [];
    }

    function sizeGuideSlide() {
        const currentSlide = document.querySelector('.slide-container.active');
        const direction = this.dataset.direction;
        let currentSlideNum = currentSlide.dataset.slide;
        $('.js-slide-size-guide').removeClass('disabled');
        if(direction === 'next') {
            currentSlideNum++
        }
        if(direction === 'prev') {
            currentSlideNum--;
        }
        if(currentSlideNum == 1) {
            $('.slide-previous.js-slide-size-guide').addClass('disabled');
        }
        if(currentSlideNum == 5) {
            $('.slide-controls').css('display', 'none');
            $('.slide-next.js-slide-size-guide').addClass('disabled');
        }
        $('.slide-container').removeClass('active');
        $('.slide-container[data-slide="'+currentSlideNum+'"]').addClass('active');
    }

    const enableSliders = () => {
        productSliders.forEach(slider => {
            let product_slider = new Flickity(slider);
            enabledSliders.push(product_slider);
        });
    }

    // Flickity slider events hooked in from stead-lane-custom.js

    const slideSizeGuideBtn = document.querySelectorAll('.js-slide-size-guide');
    if(slideSizeGuideBtn.length > 0) {
        slideSizeGuideBtn.forEach(btn => {
            btn.addEventListener('click', sizeGuideSlide);
        })
    }

    const startAgainBtn = document.querySelector('.js-start-again');
    if(startAgainBtn) {
        startAgainBtn.addEventListener('click', startAgain);
    }
});
